export const FEEDBACK_FRAMEWORK_STAGE_NAME = {
  Intro: 'Intro',
  Values: 'Values',
  Confirm: 'Confirm',
  Success: 'Success',
  Error: 'Error',
  CompletedSurvey: 'CompletedSurvey',
  SaveDraft: 'SaveDraft',
};

export const FEEDBACK_FRAMEWORK_PROCESS_FORM_FIELDS = {
  RESPONSE1: 'response1',
  RESPONSE2: 'response2',
  VALUES_OF_QUALITIES: 'values_of_qualities',
};

export const ACTIVE_FRAMEWORK_INFO = 'You are unable to change anything on this form once it is launched.';

export const MIN_FF_VALUES_COUNT = 3;
export const MAX_FF_VALUES_COUNT = 8;
export const MIN_FF_QUALITIES_COUNT = 3;
export const MAX_FF_QUALITIES_COUNT = 8;

export const frameworkValuesColors = [
  { backgroundColor: '#DFD3FE', textColor: '#000000' },
  { backgroundColor: '#FF20A9', textColor: '#FFFFFF' },
  { backgroundColor: '#C4DFFF', textColor: '#000000' },
  { backgroundColor: '#C3F877', textColor: '#000000' },
  { backgroundColor: '#AB3193', textColor: '#FFFFFF' },
  { backgroundColor: '#FDB481', textColor: '#000000' },
  { backgroundColor: '#58B3C1', textColor: '#FFFFFF' },
  { backgroundColor: '#CFBD9D', textColor: '#000000' },
];

export const DEADLINE_BY = {
  ADMIN: 'admin',
  RECIPIENT: 'recipient',
};

export const deadlineByOptions = [
  {
    id: 'change_deadline_by_admin',
    label: "Yes, I'd like to choose the deadline myself",
    value: DEADLINE_BY.ADMIN,
  },
  {
    id: 'change_deadline_by_recipient',
    label: 'No, let feedback recipients choose their own deadline',
    value: DEADLINE_BY.RECIPIENT,
  },
];

export const FF_EVALUATION_BANDS = [
  {
    from: 0,
    to: 2,
    name: 'Not visible',
    colours: ['#2c2a43', '#374168'],
  },
  {
    from: 2,
    to: 4,
    name: 'Slightly visible',
    colours: ['#42578d', '#4e6fb3'],
  },
  {
    from: 4,
    to: 6,
    name: 'Often visible',
    colours: ['#5985d8', '#659dfe'],
  },
  {
    from: 6,
    to: 8,
    name: 'Very visible',
    colours: ['#6db1f9', '#75c4f5'],
  },
  {
    from: 8,
    to: 10,
    name: 'Extremely visible',
    colours: ['#7cd8f2', '#84ebee'],
  },
];

export const FF_EVALUATION_SCALE_MAX = FF_EVALUATION_BANDS[FF_EVALUATION_BANDS.length - 1].to;

export const FF_VALUE_QUALITY_COLORS = FF_EVALUATION_BANDS.flatMap((band) => band.colours);

export const FF_EVALUATION_DESCRIPTIONS = FF_EVALUATION_BANDS.map((band) => band.name);
